<!-- <mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item href="/agenda">Agenda</a>
      <a mat-list-item href="/nieuws">Nieuws</a>
      <a mat-list-item href="/info">Info</a>
      <a mat-list-item href="/kaarten">Kaarten</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>-->
    <ng-image-slider [images]="imageObject" [imageSize]="imageSize" [infinite]="true" [autoSlide]="false" #nav></ng-image-slider>
    <mat-toolbar color="primary">
      <!-- <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button> -->
      <div class="top-buttons">        
         <a (click)="goto('agenda')"><span><mat-icon>music_note</mat-icon>agenda</span></a>
        <!--<a href="/nieuws"><span><mat-icon>reorder</mat-icon>nieuws</span></a>
        <a href="/info"><span><mat-icon>feedback</mat-icon>info</span></a> -->
        <a (click)="goto('kaarten')"><span><mat-icon>card_membership</mat-icon>kaarten</span></a>
      </div>
      
    </mat-toolbar> 
 <div id="main-content" ><ng-content select=".main-content" > </ng-content></div>
    <!--  </mat-sidenav-content>
</mat-sidenav-container> -->
